(() => {
  'use strict';
  const permitted = new Set(['H2','H3','H4','P','TABLE','THEAD','TBODY','TFOOT','TR','TH','TD','UL','OL','LI','STRONG','B','EM','I','BR','CAPTION']);
  function clean(source, extract) {
    if (!source) return null;
    const doc = new DOMParser().parseFromString(source, 'text/html');
    const fragment = document.createElement('div');
    if (extract) {
      const heading = [...doc.querySelectorAll('h2,h3,h4')].find(e => /^size\s*(guide|chart)\b/i.test(e.textContent.trim()));
      if (!heading) return null;
      fragment.append(heading.cloneNode(true));
      let next = heading.nextSibling;
      while (next && !(next.nodeType === 1 && /^H[1-4]$/.test(next.tagName))) {
        fragment.append(next.cloneNode(true)); next = next.nextSibling;
      }
    } else fragment.append(...doc.body.childNodes);
    // Content is confined to static sizing HTML; never run source scripts or styles.
    fragment.querySelectorAll('script,style,iframe,object,embed,form,input,button,svg').forEach(e => e.remove());
    for (const e of [...fragment.querySelectorAll('*')].reverse()) {
      if (!permitted.has(e.tagName)) { e.replaceWith(...e.childNodes); continue; }
      for (const attribute of [...e.attributes]) {
        if (!['colspan','rowspan','scope'].includes(attribute.name)) e.removeAttribute(attribute.name);
      }
    }
    if (!fragment.textContent.trim() || /warrant(?:y|ies)|guarantee\s+coverage/i.test(fragment.textContent)) return null;
    // Present legacy label/value lists as the same compact chart used by newer HTML.
    for (const list of [...fragment.querySelectorAll('ul')]) {
      const rows = [...list.children].map(li => li.textContent.trim().match(/^([^:]+):\s*(.+)$/));
      if (!rows.length || rows.some(row => !row)) continue;
      const table = document.createElement('table');
      const head = table.createTHead().insertRow();
      ['Measurement', 'Value'].forEach(text => { const th = document.createElement('th'); th.scope = 'col'; th.textContent = text; head.append(th); });
      const body = table.createTBody();
      rows.forEach(row => { const tr = body.insertRow(); [row[1],row[2]].forEach(text => { tr.insertCell().textContent = text; }); });
      list.replaceWith(table);
    }
    fragment.querySelectorAll('table').forEach(table => {
      const headings = [...table.querySelectorAll('thead th')];
      const rows = [...table.querySelectorAll('tbody tr')];
      if (headings.length > 2 && /^size$/i.test(headings[0].textContent.trim()) && rows.length === 1 && rows[0].cells.length === headings.length) {
        const compact = document.createElement('table');
        const header = compact.createTHead().insertRow();
        ['Measurement', rows[0].cells[0].textContent].forEach(text => { const th=document.createElement('th'); th.scope='col'; th.textContent=text; header.append(th); });
        const body = compact.createTBody();
        headings.slice(1).forEach((heading,index) => { const row=body.insertRow(); row.insertCell().textContent=heading.textContent; row.insertCell().textContent=rows[0].cells[index+1].textContent; });
        table.replaceWith(compact);
      }
    });
    if (!/how to measure/i.test(fragment.textContent)) {
      const instructions = [];
      if (/waist/i.test(fragment.textContent)) instructions.push('Waist: measure around your natural waist.');
      if (/hip/i.test(fragment.textContent)) instructions.push('Hips: measure around the fullest part of your hips.');
      if (instructions.length) {
        const heading=document.createElement('h3'); heading.textContent='How to measure'; fragment.append(heading);
        const list=document.createElement('ol'); instructions.forEach(text=>{const li=document.createElement('li');li.textContent=text;list.append(li);}); fragment.append(list);
      }
    }
    fragment.querySelectorAll('table').forEach(table => {
      const scroll = document.createElement('div'); scroll.className = 'sdp-size-table-scroll'; scroll.tabIndex = 0;
      scroll.setAttribute('role', 'region'); scroll.setAttribute('aria-label', 'Size chart. Scroll horizontally for all measurements.');
      table.replaceWith(scroll); scroll.append(table);
    });
    window.SecondipityApparel?.illustrateMeasurements(fragment);
    return fragment;
  }
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-size-guide-data]').textContent);
    const section = root.closest('.shopify-section') || document;
    const tabs = root.closest('.product-tabs-section');
    if (!tabs) return;
    const nav = tabs.querySelector('[role="tablist"]');
    const tab = document.createElement('button'); tab.type = 'button'; tab.className = 'product-tab-btn';
    tab.dataset.tab = 'size-guide'; tab.dataset.sizeGuideTab = ''; tab.setAttribute('role','tab'); tab.setAttribute('aria-selected','false');
    tab.id = `SizeGuideTab-${root.dataset.productId}`; tab.textContent = 'Size Guide';
    const panel = document.createElement('div'); panel.className = 'product-tab-panel'; panel.dataset.tabPanel = 'size-guide';
    panel.id = `size-guide-${root.dataset.productId}`; panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',tab.id); panel.hidden = true;
    tab.setAttribute('aria-controls',panel.id);
    const tabContent = document.createElement('div'); tabContent.className = 'sdp-size-content'; panel.append(tabContent);
    nav.querySelector('[data-tab="description"]').after(tab); tabs.querySelector('.product-tabs').append(panel);
    const dialog = root.querySelector('dialog'); let opener;
    function close() { dialog.close(); }
    dialog.addEventListener('close', () => { document.body.classList.remove('sdp-size-open'); opener?.focus(); });
    root.querySelector('[data-size-guide-close]').addEventListener('click',close);
    dialog.addEventListener('click', e => { if (e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) close(); } });
    // Capture links once here: the size picker does not replace its link during variant updates.
    const links = [...section.querySelectorAll('.size-guide-link')];
    links.forEach(link => link.addEventListener('click', e => { e.preventDefault(); if(tab.hidden)return; opener=link; dialog.showModal(); document.body.classList.add('sdp-size-open'); root.querySelector('[data-size-guide-close]').focus(); }));
    tab.addEventListener('click', () => {
      tabs.querySelectorAll('.product-tab-btn[role="tab"]').forEach(button => { const active=button===tab; button.classList.toggle('is-active',active); button.setAttribute('aria-selected',String(active)); });
      tabs.querySelectorAll('.product-tab-panel').forEach(p => { p.hidden=p!==panel; p.classList.toggle('is-active',p===panel); });
    });
    function update(id) {
      const variant = data.variants.find(v=>String(v.id)===String(id));
      const guide = clean(variant?.chart || data.chart, false) || clean(variant?.description, true) || (data.allowLegacy && (clean(data.description, true) || clean(data.legacyDescription, true)));
      root.hidden=!guide; tab.hidden=!guide; links.forEach(link => { link.hidden=!guide; link.setAttribute('aria-haspopup','dialog'); });
      tabContent.replaceChildren(); root.querySelector('[data-size-guide-modal-content]').replaceChildren();
      if(guide) {
        tabContent.append(guide.cloneNode(true)); root.querySelector('[data-size-guide-modal-content]').append(guide.cloneNode(true));
        // Move only a bounded legacy chart block out of the visible description.
        // The CA-fed source is preserved, and unrelated product details remain.
        const description=tabs.querySelector('.product-description-rte');
        const heading=description && [...description.querySelectorAll('h2,h3,h4')].find(e=>/^size\s*(guide|chart)\b/i.test(e.textContent.trim()));
        if(heading) {
          let next=heading.nextSibling;
          while(next) {
            const following=next.nextSibling;
            if(next.nodeType===3 && !next.textContent.trim()) next.remove();
            else if(next.nodeType===1 && ['P','TABLE','UL','OL'].includes(next.tagName)) {
              const isChart=['TABLE','UL','OL'].includes(next.tagName); next.remove(); if(isChart)break;
            }
            else break;
            next=following;
          }
          heading.remove();
        }
      }
      else { if(dialog.open)close(); if(tab.classList.contains('is-active'))tabs.querySelector('[data-tab="description"]').click(); }
    }
    update(data.selected);
    document.addEventListener('variant:change',e=> { if(e.detail?.variant)update(e.detail.variant.id); });
  }
  function boot(){ document.querySelectorAll('[data-size-guide-root]').forEach(initialize); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
